import {
  archivesMedium,
  barChartMedium,
  cfgPageMedium,
  tickMedium,
  dashboardMedium,
  goBackMedium,
  gwCompletedMedium,
  gwStatsMedium,
  hardhatExtraBold,
  infosMedium,
  locationMedium,
  logoutMedium,
  meetingMedium,
  pendingMedium,
  problemsMedium,
  scheduleMedium,
  settingsMedium,
  statsMedium,
  teamMedium,
  vitalityMedium,
} from '@/assets/icons';

/**
 * Available pages in Shizen as constants
 * WARNING: Do not edit these constants as some page ids are used on the server side (eg: meetings/plannings/func.php)
 */
function SPage() { }

// DMP pages
SPage.DASHBOARD = {
  id: 10001,
  link: '/dashboard',
  componentName: 'Dashboard',
  i18nName: 'message.DASHBOARD',
  path: dashboardMedium,
  category: 'main',
};
SPage.INDICATORS = {
  id: 10002,
  link: '/indicators',
  componentName: 'Indicators',
  i18nName: 'message.INDICATORS',
  path: barChartMedium,
  category: 'main',
};
SPage.ACTION_PLANS = {
  id: 10003,
  link: '/actions',
  componentName: 'Actions',
  i18nName: 'message.ACTIONS',
  path: tickMedium,
  category: 'main',
};
SPage.PENDING = {
  id: 10004,
  link: '/pending',
  componentName: 'Pending',
  i18nName: 'message.PENDING',
  path: pendingMedium,
  category: 'main',
};
SPage.PROBLEMS = {
  id: 10005,
  link: '/problems',
  componentName: 'Problems',
  i18nName: 'message.PROBLEMS',
  path: problemsMedium,
  category: 'main',
};
SPage.SCHEDULE = {
  id: 10006,
  link: '/schedule',
  componentName: 'Schedule',
  i18nName: 'message.SCHEDULE',
  path: scheduleMedium,
  category: 'main',
};
SPage.INFORMATIONS = {
  id: 10007,
  link: '/meeting-infos',
  componentName: 'MeetingInfos',
  i18nName: 'message.INFORMATIONS',
  path: infosMedium,
  category: 'main',
};
SPage.STATS = {
  id: 10008,
  link: '/stats',
  componentName: 'Stats',
  i18nName: 'message.STATS',
  path: statsMedium,
  category: 'main',
};
SPage.ARCHIVES = {
  id: 10009,
  link: '/archives',
  componentName: 'Archives',
  i18nName: 'message.ARCHIVES',
  path: archivesMedium,
  category: 'main',
};
SPage.DETAILED_INDICATOR = {
  id: 10010,
  link: '/indicator',
  queryIdKey: 'detailedIndicatorId',
  componentName: 'DetailedIndicator',
  i18nName: 'message.DETAILED_INDICATOR',
  path: barChartMedium,
  category: 'main',
};
SPage.INDICATOR_INPUT = {
  id: 10011,
  link: '/indicator',
  queryIdKey: 'detailedIndicatorId',
  componentName: 'DetailedIndicator',
  i18nName: 'message.INDICATOR_INPUT',
  path: barChartMedium,
  queryOptions: {
    showInput: 'true',
  },
  category: 'main',
};
SPage.CFG_PAGE = {
  id: 10012,
  link: '/configurable-page',
  queryIdKey: 'pageId',
  componentName: 'ConfigurablePage',
  i18nName: 'message.CFG_PAGES',
  path: cfgPageMedium,
  category: 'main',
};
SPage.PROBLEM_SHEET = {
  id: 10013,
  link: '/problems',
  queryIdKey: 'pbSheetModalId',
  componentName: 'ProblemSheet',
  i18nName: 'message.PROBLEM_SHEET',
  path: problemsMedium,
  category: 'main',
};


// Settings pages
SPage.SETTINGS = {
  id: 20001,
  link: '/settings',
  componentName: 'Settings',
  i18nName: 'message.SETTINGS',
  path: settingsMedium,
  category: 'settings',
};
SPage.SETTINGS_MAIN = {
  id: 20002,
  link: '/settings/main',
  componentName: 'SettingsMain',
  i18nName: 'message.SETTINGS_MAIN',
  path: settingsMedium,
  category: 'settings',
};
SPage.SETTINGS_INDICATORS = {
  id: 20003,
  link: '/settings/indicators',
  componentName: 'SettingsIndicators',
  i18nName: 'message.SETTINGS_INDICATORS_THEMES',
  path: settingsMedium,
  category: 'settings',
};
SPage.SETTINGS_ACTIONS = {
  id: 20004,
  link: '/settings/actions',
  componentName: 'SettingsActions',
  i18nName: 'message.SETTINGS_ACTIONS',
  path: settingsMedium,
  category: 'settings',
};
SPage.SETTINGS_PROBLEMS = {
  id: 20005,
  link: '/settings/problems',
  componentName: 'SettingsProblems',
  i18nName: 'message.SETTINGS_PROBLEMS',
  path: settingsMedium,
  category: 'settings',
};
SPage.SETTINGS_DASHBOARD = {
  id: 20006,
  link: '/settings/dashboard',
  componentName: 'SettingsDashboard',
  i18nName: 'message.SETTINGS_DASHBOARD',
  path: settingsMedium,
  category: 'settings',
};
SPage.SETTINGS_MEETINGS = {
  id: 20007,
  link: '/settings/meetings',
  componentName: 'SettingsMeetings',
  i18nName: 'message.SETTINGS_MEETINGS',
  path: settingsMedium,
  category: 'settings',
};
SPage.SETTINGS_TEAM = {
  id: 20008,
  link: '/settings/team',
  componentName: 'SettingsTeam',
  i18nName: 'message.SETTINGS_TEAM',
  path: settingsMedium,
  category: 'settings',
};
SPage.SETTINGS_CFG_PAGES = {
  id: 20009,
  link: '/settings/configurable-pages',
  componentName: 'SettingsConfigPages',
  i18nName: 'message.CFG_PAGES',
  path: settingsMedium,
  category: 'settings',
};
SPage.SETTINGS_GW = {
  id: 20010,
  link: '/settings/gemba-walks',
  componentName: 'SettingsGw',
  i18nName: 'message.SETTINGS_GW',
  path: settingsMedium,
  category: 'settings',
};

// Meeting-specific pages
SPage.MEETING_ROLES = {
  id: 40001,
  link: '/meeting-roles',
  componentName: 'MeetingRoles',
  i18nName: 'message.MEETING_ROLES',
  path: teamMedium,
  category: 'meetings',
};
SPage.MEETING_RATING = {
  id: 40002,
  link: '/meeting-rating',
  componentName: 'MeetingRating',
  i18nName: 'message.MEETING_RATING',
  path: teamMedium,
  category: 'meetings',
};
SPage.CUSTOM_PAGE = {
  id: 40003,
  link: '/custom-page',
  componentName: 'CustomPage',
  i18nName: 'message.CUSTOM_PAGE',
  path: cfgPageMedium,
  category: 'meetings',
  deprecated: true,
};
SPage.MEETING_SAFETY = {
  id: 40004,
  link: '/meeting-safety',
  componentName: 'MeetingSafety',
  i18nName: 'message.MEETING_SAFETY',
  path: meetingMedium,
  category: 'meetings',
  deprecated: true,
};

// MGT pages
SPage.MGT_INDICATORS = {
  id: 30001,
  link: '/it-indicators',
  componentName: 'MgtIndicators',
  i18nName: 'message.INDICATORS',
  path: barChartMedium,
  category: 'management',
};
SPage.MGT_ACTIONS = {
  id: 30002,
  link: '/it-actions',
  componentName: 'MgtActions',
  i18nName: 'message.ACTIONS',
  path: tickMedium,
  category: 'management',
};
SPage.MGT_PROBLEMS = {
  id: 30003,
  link: '/it-problems',
  componentName: 'MgtProblems',
  i18nName: 'message.PROBLEMS',
  path: problemsMedium,
  category: 'management',
};
SPage.MGT_STATS = {
  id: 30004,
  link: '/it-stats',
  componentName: 'MgtStats',
  i18nName: 'message.STATS_FROM_MGT',
  path: statsMedium,
  category: 'management',
};

// GW pages
SPage.GW_TEMPLATES = {
  id: 50001,
  link: '/gw-templates',
  componentName: 'GwTemplates',
  i18nName: 'message.GW_TEMPLATES',
  path: hardhatExtraBold,
  category: 'gembaWalk',
};
SPage.GW_COMPLETED_LIST = {
  id: 50002,
  link: '/gemba-walks',
  componentName: 'GembaWalks',
  i18nName: 'message.GW_COMPLETE',
  path: gwCompletedMedium,
  category: 'gembaWalk',
};
SPage.GW_STATS = {
  id: 50003,
  link: '/gw-stats',
  componentName: 'GwStats',
  i18nName: 'message.GW_STATS',
  path: gwStatsMedium,
  category: 'gembaWalk',
};
SPage.GW_CREATION = {
  id: 50004,
  link: '/gw-creation',
  componentName: 'GwCreation',
  i18nName: 'message.GW_CREATION',
  path: hardhatExtraBold,
  category: 'gembaWalk',
  excludeFromPagePicker: true,
};
SPage.GW_START = {
  id: 50005,
  link: '/gw-start',
  componentName: 'GwStart',
  i18nName: 'message.GW_START',
  path: hardhatExtraBold,
  category: 'gembaWalk',
  excludeFromPagePicker: true,
};
SPage.GW_ONGOING = {
  id: 50006,
  link: '/gw-ongoing',
  componentName: 'GwOngoing',
  i18nName: 'message.GW_ONGOING',
  path: hardhatExtraBold,
  category: 'gembaWalk',
  excludeFromPagePicker: true,
};
SPage.GW_COMPLETED = {
  id: 50007,
  link: '/gw-completed',
  queryIdKey: 'last',
  componentName: 'GwCompleted',
  i18nName: 'message.GW_LAST_COMPLETE',
  path: gwCompletedMedium,
  category: 'gembaWalk',
};
SPage.GW_RATING = {
  id: 50008,
  link: '/gw-rating',
  componentName: 'GwRating',
  i18nName: 'message.GW_RATING',
  path: gwCompletedMedium,
  category: 'gembaWalk',
  excludeFromPagePicker: true,
};
SPage.GW_CHECKLISTS = {
  id: 50009,
  link: '/gw-checklists',
  componentName: 'GwChecklists',
  i18nName: 'message.GW_CHECKLISTS',
  path: tickMedium,
  category: 'gembaWalk',
};
SPage.GW_INDICATORS = {
  id: 50010,
  link: '/gw-indicators',
  componentName: 'GwIndicators',
  i18nName: 'message.GW_INDICATORS',
  path: barChartMedium,
  category: 'gembaWalk',
};

// Config pages
SPage.CONFIG = {
  id: 60001,
  link: '/config',
  componentName: 'Config',
  i18nName: 'message.CONFIG',
  path: settingsMedium,
  category: 'config',
};
SPage.CFG_DETAILS = {
  id: 60002,
  link: '/config/details',
  componentName: 'ConfigDetails',
  i18nName: 'message.DETAILS',
  path: dashboardMedium,
  category: 'config',
};
SPage.CFG_TEAMS = {
  id: 60003,
  link: '/config/teams',
  componentName: 'ConfigTeams',
  i18nName: 'message.TEAMS',
  path: teamMedium,
  category: 'config',
};
SPage.CFG_INDICATORS = {
  id: 60004,
  link: '/config/indicators',
  componentName: 'ConfigIndicators',
  i18nName: 'message.INDICATORS',
  path: barChartMedium,
  category: 'config',
};
SPage.CFG_PROBLEMS = {
  id: 60005,
  link: '/config/problems',
  componentName: 'ConfigProblems',
  i18nName: 'message.PROBLEMS',
  path: problemsMedium,
  category: 'config',
};
SPage.CFG_LOCATIONS = {
  id: 60006,
  link: '/config/locations',
  componentName: 'ConfigLocations',
  i18nName: 'message.LOCATIONS',
  path: locationMedium,
  category: 'config',
};
SPage.CFG_CFG_PAGES = {
  id: 60007,
  link: '/config/configurable-pages',
  componentName: 'ConfigConfigurablePages',
  i18nName: 'message.CFG_PAGES',
  path: cfgPageMedium,
  category: 'config',
};
SPage.CFG_MEETINGS = {
  id: 60008,
  link: '/config/meetings',
  componentName: 'ConfigMeetings',
  i18nName: 'message.SETTINGS_MEETINGS',
  path: meetingMedium,
  category: 'config',
};
SPage.CFG_LEAVE = {
  id: 60009,
  link: '',
  componentName: '',
  i18nName: 'message.BACK',
  path: goBackMedium,
  category: 'config',
};
SPage.CFG_ACTIONS = {
  id: 60010,
  link: '/config/actions',
  componentName: 'ConfigActions',
  i18nName: 'message.ACTIONS',
  path: tickMedium,
  category: 'config',
};

// General pages
SPage.LOGIN = {
  id: 70001,
  link: '/login',
  componentName: 'Login',
  i18nName: 'message.LOGIN',
  path: logoutMedium,
  category: 'general',
};
SPage.LOGOUT = {
  id: 70002,
  link: '/logout',
  componentName: 'Logout',
  i18nName: 'message.LOGOUT',
  path: logoutMedium,
  category: 'general',
};

// Vitality Hub
SPage.VITALITY_HUB = {
  id: 80001,
  link: '/vitality-hub',
  componentName: 'VitalityHub',
  i18nName: 'message.VITALITY_HUB',
  path: vitalityMedium,
  category: 'vitalityHub',
};


SPage.fromId = {};
Object.values(SPage).forEach((page) => {
  if (page.id) {
    SPage.fromId[`${page.id}`] = page;
  }
});

SPage.fromLink = {};
Object.values(SPage).forEach((page) => {
  if (page.link) {
    SPage.fromLink[`${page.link}`] = page;
  }
});


// Create categories for each type of page
SPage.categories = {
  main: {
    pages: Object.values(SPage).filter(p => p.category === 'main'),
    i18nName: 'message.MAIN_PAGES',
  },
  settings: {
    pages: Object.values(SPage).filter(p => p.category === 'settings'),
    i18nName: 'message.SETTINGS_PAGES',
  },
  meetings: {
    pages: Object.values(SPage).filter(p => p.category === 'meetings'),
    i18nName: 'message.MEETING_PAGES',
  },
  management: {
    pages: Object.values(SPage).filter(p => p.category === 'management'),
    i18nName: 'message.MGT_PAGES',
  },
  gembaWalk: {
    pages: Object.values(SPage).filter(p => p.category === 'gembaWalk'),
    i18nName: 'message.GW_PAGES',
  },
  config: {
    pages: Object.values(SPage).filter(p => p.category === 'config'),
    i18nName: '',
  },
  general: {
    pages: Object.values(SPage).filter(p => p.category === 'general'),
    i18nName: '',
  },
  vitalityHub: {
    pages: Object.values(SPage).filter(p => p.category === 'vitalityHub'),
    i18nName: '',
  },
};
SPage.configPageLinks = SPage.categories.config.pages.map(page => page.link);

export default SPage;
